// @ts-nocheck
import { Divider, Menu, MenuItem, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../../../utils/styles/getCssVariables";
import { useEffect, useMemo, useState } from "react";
import styles from "./additionaStyles.module.css";
import { Check } from "@mui/icons-material";

export default function RightClick({
  clickEvents,
  contextMenu,
  handleClose,
  metaData,
}) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedSubType, setSelectedSubType] = useState(null);
  // const isYellow = useMemo(() => {
  //   return contextMenu?.field?.includes("contractor");
  // }, [contextMenu?.field]);

  const isYellow = useMemo(() => {
    return false;
  }, []);

  const bottomOptions = useMemo(() => {
    if (metaData?.isEventSplit) {
      if (contextMenu?.isSplit) {
        if (contextMenu?.field?.includes("contractor")) {
          return [
            {
              id: 1,
              title: "Copy to contractor only rows",
              subType: null,
            },
            {
              id: 2,
              title: "Copy to contractor & common rows only",
              subType: "COMMON",
            },
            {
              id: 3,
              title: "Copy to all rows",
              subType: "ALL",
            },
          ];
        } else {
          return [
            {
              id: 1,
              title: "Copy to client only rows",
              subType: "CLIENT_ONLY",
            },
            {
              id: 2,
              title: "Copy to client & common rows only",
              subType: null,
            },
            {
              id: 3,
              title: "Copy to all rows",
              subType: "ALL",
            },
          ];
        }
      } else {
        return [
          {
            id: 1,
            title: "Copy to common rows only",
            subType: "COMMON_ONLY",
          },
          {
            id: 2,
            title: "Copy on all rows",
            subType: "ALL",
          },
          {
            id: 3,
            title: "Copy on common rows & client rows",
            subType: null,
          },
          {
            id: 4,
            title: "Copy on common rows and contractor rows",
            subType: "COMMON_CONTRACTOR",
          },
        ];
      }
    } else {
      return null;
    }
  }, [metaData?.isEventSplit, contextMenu?.field, contextMenu?.isSplit]);

  useEffect(() => {
    if (bottomOptions) {
      setSelectedOption(1);
      setSelectedSubType(bottomOptions?.[0]?.subType);
    }
  }, [bottomOptions]);

  return (
    <Menu
      open={contextMenu?.status}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenu != null &&
        contextMenu.mouseX != null &&
        contextMenu.mouseY != null
          ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
          : undefined
      }
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "0.5rem !important",
        },
        "& ul": {
          border: `1px solid ${getCssVariableHandler({ variableName: isYellow ? "--primary-yellow-dark-hex" : "--primary-pink-hex" })}`,
          overflow: "hidden",
          borderRadius: "0.5rem",
        },
        "& li:hover": {
          backgroundColor: getCssVariableHandler({
            variableName: isYellow
              ? "--primary-yellow-dark-hex"
              : "--primary-pink-hex",
          }),
        },
      }}
    >
      {clickEvents?.applyToAll && (
        <MenuItem onClick={() => clickEvents?.applyToAll(selectedSubType)}>
          Apply to all
        </MenuItem>
      )}
      {clickEvents?.applyToBelowAll && (
        <MenuItem onClick={() => clickEvents?.applyToBelowAll(selectedSubType)}>
          Apply to below
        </MenuItem>
      )}
      {clickEvents?.applyToAboveAll && (
        <MenuItem onClick={() => clickEvents?.applyToAboveAll(selectedSubType)}>
          Apply to above
        </MenuItem>
      )}
      {clickEvents?.applyToSelected && (
        <MenuItem onClick={() => clickEvents?.applyToSelected(selectedSubType)}>
          Apply to selected
        </MenuItem>
      )}
      {clickEvents?.archiveEvent && (
        <MenuItem onClick={clickEvents?.archiveEvent}>
          {metaData?.isArchived ? "Unarchive Event" : "Archive Event"}
        </MenuItem>
      )}
      {clickEvents?.unmarkDuplicate && (
        <MenuItem onClick={clickEvents?.unmarkDuplicate}>
          Unmark Duplicate
        </MenuItem>
      )}
      {clickEvents?.editEvent && (
        <MenuItem onClick={clickEvents?.editEvent}>Edit Event</MenuItem>
      )}
      {clickEvents?.cancelEvent && (
        <MenuItem onClick={clickEvents?.cancelEvent}>Cancel Event</MenuItem>
      )}
      {clickEvents?.deleteEvent && (
        <MenuItem onClick={clickEvents?.deleteEvent}>Delete Event</MenuItem>
      )}
      {clickEvents?.travelDays && (
        <MenuItem onClick={clickEvents?.travelDays}>Add Travel Days</MenuItem>
      )}
      {clickEvents?.addReimbursement && (
        <MenuItem onClick={clickEvents?.addReimbursement}>
          Add Reimbursement
        </MenuItem>
      )}
      {clickEvents?.addDeduction && (
        <MenuItem onClick={clickEvents?.addDeduction}>Add Deduction</MenuItem>
      )}

      {bottomOptions && (
        <div className={styles["option-container"]}>
          <Divider
            sx={{
              width: "90%",
              borderBottom: "2px solid",
              borderColor: getCssVariableHandler({
                variableName: "--primary-pink-hex",
              }),
              my: 1,
              mx: "auto",
            }}
          />
          {bottomOptions?.map((opt) => {
            const isSelected = selectedOption === opt?.id;
            const className = isSelected ? styles["selected"] : null;
            return (
              <Typography
                sx={{
                  width: "100%",
                  cursor: "pointer",
                }}
                className={className}
                key={opt?.id}
                onClick={() => {
                  setSelectedOption(opt?.id);
                  setSelectedSubType(opt?.subType);
                }}
              >
                <Typography className={styles["title"]}>
                  {opt?.title}
                  {isSelected ? <Check /> : null}
                </Typography>
              </Typography>
            );
          })}
        </div>
      )}
    </Menu>
  );
}

export function RightCheckBoxClick({ clickEvents, contextMenu, handleClose }) {
  if (
    !clickEvents?.copyRows &&
    !clickEvents?.insertBelow &&
    !clickEvents?.insertAbove &&
    !clickEvents?.insertPaste
  ) {
    return null;
  }

  return (
    <Menu
      open={contextMenu?.status}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenu != null &&
        contextMenu.mouseX != null &&
        contextMenu.mouseY != null
          ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
          : undefined
      }
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "0.5rem !important",
        },
        "& ul": {
          border: `1px solid ${getCssVariableHandler({ variableName: "--primary-pink-hex" })}`,
          overflow: "hidden",
          borderRadius: "0.5rem",
        },
        "& li:hover": {
          backgroundColor: getCssVariableHandler({
            variableName: "--primary-pink-hex",
          }),
        },
      }}
    >
      {clickEvents?.copyRows && (
        <MenuItem onClick={clickEvents?.copyRows}>Copy</MenuItem>
      )}
      {clickEvents?.insertPaste && (
        <MenuItem onClick={clickEvents?.insertPaste}>
          Paste on respective dates
        </MenuItem>
      )}
      {clickEvents?.insertAbove && (
        <MenuItem onClick={clickEvents?.insertAbove}>
          Insert above this row
        </MenuItem>
      )}
      {clickEvents?.insertBelow && (
        <MenuItem onClick={clickEvents?.insertBelow}>
          Insert below this row
        </MenuItem>
      )}
    </Menu>
  );
}

RightClick.propTypes = {
  clickEvents: PropTypes.object,
  contextMenu: PropTypes.object,
  handleClose: PropTypes.func,
  metaData: PropTypes.object,
};

RightCheckBoxClick.propTypes = {
  clickEvents: PropTypes.object,
  contextMenu: PropTypes.object,
  handleClose: PropTypes.func,
};
